const Title = () => {
  return (
    <div className="container mx-auto flex w-full justify-center">
      <div className="container w-5/6 xl:w-3/4">
        <h1 className="text-center font-bold text-4xl sm:text-6xl">
          The world&apos;s most powerful{" "}
          <span className="bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text font-bold text-transparent">
            digital privacy software.
          </span>
        </h1>
      </div>
    </div>
  );
};

export default Title;
